import React, { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useModal } from "../context/ModalContext";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const { openLogin } = useModal();
  const location = useLocation();

  useEffect(() => {
    if (!user && !loading) {
      openLogin(); // open login modal
    }
  }, [user, loading, openLogin]);

  if (loading) {
    return null; // wait until auth is initialized
  }

  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
